import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * Único bloque de precio de la landing. Un solo precio vigente: no se muestra
 * precio anterior, descuento ni cuotas porque no existen datos reales.
 * PLACEHOLDER COMERCIAL: si más adelante hay un precio de lista verificable,
 * se agrega arriba del precio vigente.
 */
export function PriceBlock({
  className = '',
  size = 'md'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3.2rem] sm:text-[4.2rem]' : 'text-[2.5rem] sm:text-[3rem]';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-207" data-mp="1tw8j78psp0ip">
      <div className="flex items-start gap-2" data-id="element-208" data-mp="1txjl12zojy76">
        <p className={`font-display leading-[0.9] tabular-nums text-charcoal ${current}`} data-id="element-209" data-mp="1p507g60zt32d">
          {PRICE.current}
        </p>
        <span className="mt-2 font-sans text-xs font-bold uppercase tracking-[0.16em] text-charcoal/45 sm:text-sm" data-id="element-210" data-mp="11emnl2skaaiv">
          {PRICE.currency}
        </span>
      </div>
      <p className="mt-3 font-sans text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-charcoal/55" data-id="element-211" data-mp="1s09p7c7zs7ij">
        {PRICE.note}
      </p>
    </div>;
}